/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import {IconDocumentVehicleGate} from "../../../../../../../components/buttons/IconButtons";

/**
 * Card of the gate log: its header and the scrollable body that holds the
 * groups registered at the gate.
 *
 * The forms that only ask for materials name the card after them, so the icon
 * and the title of the header are declared by the form that renders it, the
 * same way the action the card is written with is.
 *
 * A card named after the direction of the movement reads its icon in the box
 * of the direction, which is the one every form names that movement with, so
 * the background and the color of the icon are declared along with it.
 */
const GateLogCard = ({
    t,
    Icon = IconDocumentVehicleGate,
    title = 'gate_log',
    iconBackground = null,
    iconColor = null,
    action = null,
    contentRef,
    children
}) => {
    return (
        <div className={"background-general-00 border-radius-8px border-full-shades-300"}>
            <div className={"col-12 p-3 background-shades-50 border-radius-top-8px border-bottom-shades-300 h-72px d-flex align-items-center justify-content-between"}>
                <div className={"d-flex align-items-center minw-0"}>
                    <div className={`mr-2 d-flex align-items-center ${iconBackground
                        ? `${iconBackground} p-2 border-radius-8px`
                        : ''}`}>
                        <Icon className={iconColor || ''}/>
                    </div>
                    <p className={"fs-16px ibl-font-w-600"}>{t(title)}</p>
                </div>
                {action}
            </div>
            <div ref={contentRef} className={"overflow-y-auto"}>
                {children}
            </div>
        </div>
    );
};

export default GateLogCard;
